import { render, staticRenderFns } from "./BannerIncomingCall.vue?vue&type=template&id=63077a26"
import script from "./BannerIncomingCall.vue?vue&type=script&lang=js"
export * from "./BannerIncomingCall.vue?vue&type=script&lang=js"
import style0 from "./BannerIncomingCall.vue?vue&type=style&index=0&id=63077a26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports